export default "__VITE_ASSET__Ul2KqJEz__"